import React from 'react'
import {Page} from 'react-onsenui';
import {withRouter} from "react-router-dom"
import connect from "react-redux/es/connect/connect";
import { Steps, Hints } from 'intro.js-react';
import {hideLoaderMessage, showLoaderMessage} from "../../modules/loader";
import {showToastMessage} from "../../modules/toast";
import {showAlertMessage} from "../../modules/alert";
import {showTutorial, hideTutorial} from "../../modules/tutorial";


class TutorialMessage extends React.Component {
    state = {
        steps: [],
        initialStep: 0
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.props.sort !== nextProps.sort){
            this.setSteps(nextProps.sort);
        }
    }

    setSteps = (sort) => {
        let steps = [];
        switch (sort){
            case 'ENTIRE_OVERVIEW':
                steps = [
                    {intro: '피크니키에 오신 것을 환영합니다. 피크니키에 대해 간단하게 소개해 드리겠습니다.',},
                    {
                        element: '.TUTO_HOME_MY_LIST',
                        intro: '피크니키에서는 나만의 나들이 일정을 제작하고 이용할 수 있습니다.',
                    },
                    {
                        element: '.TUTO_HOME_USER_LIST',
                        intro: '또한 공유를 허용한 다른 유저들의 일정을 바로 이용하거나, 편집 허용시 편집하여 이용할 수 있습니다.',
                    },
                    {
                        element: '.TUTO_HOME_SIMPLE_SEARCH',
                        intro: '일정 간편 검색을 이용하여 일정을 간단하게 검색하여 이용할 수도 있습니다.',
                    },
                    {
                        element: '.TUTO_SIDE_BUTTON',
                        intro: '우측 상단의 버튼을 누르면 피크니키에서 사용할 수 있는 모든 메뉴와 설정을 볼 수 있습니다.',
                    },
                    {
                        intro: '지금 제작된 일정 중 하나를 열어보세요. 사용자 리뷰와 길찾기와 같은 다양한 기능을 확인하실 수 있습니다.',
                    },
                ];
                break;
            case 'SCHEDULE_VIEW':
                steps = [
                    {intro: '이곳은 본인 또는 공유를 허용한 다른 사람의 일정을 볼 수 있는 영역입니다.',},
                    {
                        element: '.TUTO_NAVER_MAP',
                        intro: '지도에서는 일정에 포함된 장소의 위치와 순서를 확인할 수 있습니다.',
                    },
                    {
                        element: '.TUTO_SCHEDULE_LIST',
                        intro: '하단 리스트에서는 각 장소의 이름과 개략적인 정보를 확인할 수 있습니다. 클릭하시면 네이버 플레이스에서 제공하는 장소에 대한 정보 및 리뷰가 보여집니다.',
                    },
                    {
                        element: '.TUTO_SHARE_BUTTON',
                        intro: '공유 메뉴에서는 SNS를 이용해 해당 일정을 공유할 수 있습니다.',
                    },
                    {
                        element: '.TUTO_TRAFFIC_CONDITION_BUTTON',
                        intro: '교통 메뉴에서는 각 장소간 경로를 네이버 길찾기를 통해 확인할 수 있습니다.',
                    },
                    {
                        intro: '앱에서는 각 장소를 목적지로 한 네이버 네비게이션을 이용할 수 있습니다. (앱 이외에서는 표시되지 않습니다.)',
                    },
                    {
                        element: '.TUTO_SCHEDULE_DESCRIPTION_TAB_BUTTON',
                        intro: '"설명 + 댓글" 탭에서는 작성자가 쓴 일정에 대한 설명과 다른 사용자들의 댓글을 확인할 수 있습니다.',
                    },
                    {
                        intro: '설명하지 않은 일정 영역에 있는 다양한 기능들을 직접 확인해보세요.',
                    },
                ];
                break;
            case 'CREATE_SCHEDULE':
                steps = [
                    {intro: '이곳은 새로운 일정을 제작하는 영역입니다.',},
                    {
                        element: '.TUTO_CREATE_PLAN_TAB_PLAYING',
                        intro: '하단에는 먹을곳, 놀곳, 잘곳 세가지 탭이 있습니다. 각 탭을 클릭하면 상단 지도 내 해당 유형에 속한 나들이 장소들이 지도와 리스트에 표시됩니다.',
                    },
                    {
                        element: '.TUTO_CREATE_NAVER_MAP',
                        intro: '여기가 지도입니다. 지도에 표시된 마커의 번호와 하단 리스트의 번호는 동일한 장소를 가리킵니다. 지도를 움직이면 나타나는 "여기에서 검색" 버튼을 클릭하면 갱신된 마커와 리스트가 표시됩니다.',
                    },
                    {
                        element: '.TUTO_CREATE_SEARCH_TYPE_PLAYING',
                        intro: '이 버튼을 클릭하면 유형 내 상세 유형을 선택할 수 있습니다.',
                    },
                    {
                        element: '.TUTO_CREATE_SEARCH_BUTTON',
                        intro: '이 버튼을 클릭하면 장소 이름으로 장소를 검색할 수 있습니다.',
                    },
                    {intro: '지도의 마커나 리스트 중 하나를 클릭하면 네이버 플레이스에서 제공하는 장소에 대한 정보 및 리뷰가 보여집니다.',},
                    {
                        /*element: '.TUTO_CREATE_ADD_SCHEDULE',*/
                        intro: '해당 장소가 마음에 들면 우측 하단의 "일정에 담기" 버튼을 클릭하여 일정에 추가합니다.',
                    },
                    {
                        element: '.TUTO_CREATE_PLAN_TAB_SHOW_EXPECTED_SCHEDULE',
                        intro: '이 버튼을 클릭하면 현재까지 담은 일정들을 볼 수 있습니다.',
                    },
                    {
                        /*element: '.TUTO_CREATE_SAVE_SCHEDULE_BUTTON',*/
                        intro: '이곳에서 담겨진 장소들의 순서를 변경하거나 삭제하고, 장소에 대한 설명을 입력할 수 있습니다. 편집이 완료되면 우측 하단의 일정 저장 버튼을 클릭합니다.',
                    },
                    {
                        intro: '이곳에서 일정의 제목과 설명 등을 입력하고 "예"를 클릭하면 일정이 최종 저장됩니다.',
                    },
                    {
                        intro: '일정을 제작하여 직접 활용하거나 다른 유저들과 공유해보세요. 설명하지 않은 일정 제작 기능들을 직접 확인해보세요.',
                    },
                ];
                break;
        }
        this.setState({steps: steps, initialStep: 0});
    };

    onBeforeTutorialChange = (index, sort) => {
        switch (sort){
            case 'ENTIRE_OVERVIEW':
                if(index === 4){
                    document.getElementsByClassName('TUTO_SIDE_BUTTON')[0].click();
                }
                break;
            case 'SCHEDULE_VIEW':
                if(index === 3){
                    if(document.getElementsByClassName('TUTO_SHARE_BUTTON')[0]){
                        document.getElementsByClassName('TUTO_SHARE_BUTTON')[0].click();
                    }
                }
                else if(index === 4){
                    if(document.getElementsByClassName('TUTO_CLOSE_SHARE_BUTTON')[0]){
                        document.getElementsByClassName('TUTO_CLOSE_SHARE_BUTTON')[0].click();
                    }
                    if(document.getElementsByClassName('TUTO_TRAFFIC_CONDITION_BUTTON')[0]){
                        document.getElementsByClassName('TUTO_TRAFFIC_CONDITION_BUTTON')[0].click();
                    }
                }
                else if(index === 6){
                    if(document.getElementsByClassName('TUTO_CLOSE_TRAFFIC_CONDITION_BUTTON')[0]){
                        document.getElementsByClassName('TUTO_CLOSE_TRAFFIC_CONDITION_BUTTON')[0].click();
                    }
                    if(document.querySelectorAll('.TUTO_SCHEDULE_DESCRIPTION_TAB_INPUT')[0]){
                        document.querySelectorAll('.TUTO_SCHEDULE_DESCRIPTION_TAB_INPUT')[0].click();
                    }
                }
                break;
            case 'CREATE_SCHEDULE':
                if(index === 5){
                    if(document.querySelectorAll("div.create-plan-area > ul > li:nth-child(3) > div.list-item__center")[0]){
                        document.querySelectorAll("div.create-plan-area > ul > li:nth-child(3) > div.list-item__center")[0].click();
                    }
                }
                else if(index === 7){
                    if(document.getElementsByClassName('TUTO_CREATE_ADD_SCHEDULE')[0]){
                        document.getElementsByClassName('TUTO_CREATE_ADD_SCHEDULE')[0].click();
                    }
                }
                else if(index === 8){
                    if(document.querySelectorAll('.TUTO_CREATE_PLAN_TAB_SHOW_EXPECTED_SCHEDULE > input')[0]){
                        document.querySelectorAll('.TUTO_CREATE_PLAN_TAB_SHOW_EXPECTED_SCHEDULE > input')[0].click();
                    }
                }
                else if(index === 9){
                    if(document.querySelectorAll('.TUTO_CREATE_SAVE_SCHEDULE_BUTTON')[0]){
                        document.querySelectorAll('.TUTO_CREATE_SAVE_SCHEDULE_BUTTON')[0].click();
                    }
                }
                else if(index === 10){
                    if(document.querySelectorAll('.TUTO_CREATE_SAVE_SCHEDULE_BUTTON_NO')[0]){
                        document.querySelectorAll('.TUTO_CREATE_SAVE_SCHEDULE_BUTTON_NO')[0].click();
                    }
                }
                break;
        }
    };

    onCompleteTutorial = () => {
        /*switch (this.props.sort){
            case 'ENTIRE_OVERVIEW':
                localStorage.setItem('CONFIRMED_TUTORIAL_ENTIRE_OVERVIEW', "true");
        }*/
    };

    render() {

        return (
            <div>
                <Steps
                    enabled={this.props.show}
                    steps={this.state.steps}
                    initialStep={this.state.initialStep}
                    onExit={this.props.hideTutorial}
                    options={{
                        nextLabel: '다음',
                        prevLabel: '이전',
                        skipLabel: '그만보기',
                        doneLabel: '끝내기',
                        showStepNumbers: false,
                        exitOnOverlayClick: false
                    }}
                    onBeforeChange = {nextStepIndex =>
                        this.onBeforeTutorialChange(nextStepIndex, this.props.sort)
                    }
                    onComplete = {this.onCompleteTutorial}
                />
            </div>
        )
    }
}


const mapStateToProps = ({user, tutorial }) => ({
    userInfo: user.userInfo,
    show: tutorial.show,
    sort: tutorial.sort,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
    hideTutorial: () => dispatch(hideTutorial()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TutorialMessage))